// Screen widths in px for tailwind.config.js and useBreakpoints(); use these, not vueuse's breakpointsTailwind (its 2xl is 1536).
export const BREAKPOINTS = {
  tiny: 360,
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
}
